<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/khiJKM/tc-custom/9781460387573.jpg?1738332040464" alt="This image is the cover for the book Countess and the Cowboy"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Countess and the Cowboy
      </h1>
      <p class="bookDescription body article font2">
        <b>She married an earl—but in the wilds of Wyoming, she’s discovering a different kind of romantic hero . . .</b><br/><br/>Newly widowed, Eve Townsend is left with a grand title and not a penny to her name. She doesn’t know what future she can build in America’s Wild West . . . but she’s ready to learn, and to reunite with her family.<br/><br/>When she arrives in Wyoming, she discovers her beloved sister has died and sets about caring for her niece and nephew. But burly rancher Clint Lonigan is everywhere she turns—and a range war is brewing that will pit him against Eve’s brother-in-law. Clint is Eve’s opposite in every way—but maybe a rough-mannered cowboy is just what this genteel countess needs . . .
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Elizabeth Lane
      </h2>
      
      <p class="authorDescription body article">Elizabeth Lane has lived and travelled in many parts of the world, including Europe, Latin America and the Far East, but her heart remains in the American West, where she was born and raised. Her idea of heaven is hiking a mountain trail on a clear autumn day. She also enjoys music, animals and dancing. You can learn more about Elizabeth by visiting her website at &amp;lt;a href="http://www.elizabethlaneauthor.com"&amp;gt;www.elizabethlaneauthor.com&amp;lt;/a&amp;gt;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4a1c539c